import { z } from 'zod';

export const userBagSurveyHorizonStatusDto = z.object({
  horizon: z.number(),
  filledOut: z.boolean(),
  surveyLink: z.string().nullable(),
  startDate: z.coerce.date(),
});

export type UserBagSurveyHorizonStatusDto = z.infer<
  typeof userBagSurveyHorizonStatusDto
>;

export const userBagSurveyStatusResDto = z.object({
  horizons: z.array(userBagSurveyHorizonStatusDto),
});
export type UserBagSurveyStatusResDto = z.infer<
  typeof userBagSurveyStatusResDto
>;
